// extracted by mini-css-extract-plugin
export default {"leadershipTeam__section":"LeadershipTeam_leadershipTeam__section__ktfV+","leadershipTeam__list":"LeadershipTeam_leadershipTeam__list__egKxz"};